import React, { useState } from 'react';
import { TaggedContentTile } from 'components/molecules';
import { Button } from 'components/atoms';
import PropTypes, { any } from 'prop-types';
import * as Styled from './CreativeHubGrid.styled';

/**
 * Renders the Article Grid.
 * @param {Array} items
 * @param {number} contentCountPerPage
 * @returns {ReactElement}
 */
const CreativeHubGrid = ({ items = [], contentCountPerPage = 9 }) => {
  const [numPages, setNumPages] = useState(1);

  const renderGridPage = page => {
    const itemsToShow = items.slice(
      page * contentCountPerPage,
      (page + 1) * contentCountPerPage,
    );
    // TODO: event track for cta card click? CURATED_LIST_CTA_CLICK
    return (
      <Styled.GridPage key={page}>
        {itemsToShow.map(item => (
          <TaggedContentTile key={item.id} tile={item} />
        ))}
      </Styled.GridPage>
    );
  };

  return (
    <Styled.Container>
      {[...Array(numPages).keys()].map(page => renderGridPage(page))}
      <Styled.CtaContainer>
        {numPages * contentCountPerPage < items.length && (
          <Button
            type="secondary"
            text="View More"
            onClick={() => setNumPages(numPages + 1)}
          />
        )}
        {numPages > 1 && numPages * contentCountPerPage < items.length && (
          <Button
            type="secondary"
            text="View Less"
            onClick={() => setNumPages(numPages - 1)}
          />
        )}
      </Styled.CtaContainer>
    </Styled.Container>
  );
};

CreativeHubGrid.propTypes = {
  /**
   * List of items
   */
  items: PropTypes.arrayOf(any),
  /**
   * number of tiles per page
   */
  contentCountPerPage: PropTypes.number,
};

export default CreativeHubGrid;
